/**
 * @file 上方资产总览区域
 */
import { useFm } from '@web3/base-hooks';
import { useAssetData } from './hooks';
import { cellDataFormatter } from '@/utils/util';
import BigNumber from 'bignumber.js';
import cls from 'classnames';

import styles from './index.module.scss';

interface Props {
  showAsset: boolean;
}

const hiddenAssetText = '********';

export const Overview = (props: Props) => {
  const { showAsset } = props;

  const fm = useFm();
  const { data } = useAssetData();
  return (
    <div className={styles.container}>
      <div className={styles.amountSum}>
        <div className={styles.subTitle}>{fm('myInvestmentTotalValueUsd')}</div>
        <div className={styles.value}>
          {showAsset
            ? cellDataFormatter(data.depositAmountSum)
            : hiddenAssetText}
        </div>
      </div>
      <div
        className={cls(styles.yield, {
          [styles.green]: showAsset && BigNumber(data.yesterdayYield).gt(0),
          [styles.red]: showAsset && BigNumber(data.yesterdayYield).lt(0),
        })}
      >
        <div
          className={styles.subTitle}
        >{`${fm('yesterdayEarnings')} (USD)`}</div>
        <div className={styles.value}>
          {showAsset
            ? `${cellDataFormatter(data.yesterdayYield)}`
            : hiddenAssetText}
        </div>
      </div>
      <div
        className={cls(styles.yield, {
          [styles.green]: showAsset && BigNumber(data.yield).gt(0),
          [styles.red]: showAsset && BigNumber(data.yield).lt(0),
        })}
      >
        <div
          className={styles.subTitle}
        >{`${fm('cumulativeYield')} (USD)`}</div>
        <div className={styles.value}>
          {showAsset ? `${cellDataFormatter(data.yield)}` : hiddenAssetText}
        </div>
      </div>
    </div>
  );
};
